module.exports = __webpack_public_path__ + "static/media/register_node_decor_1.5752da3e.png";